import {
    HelixSearchV2ShortlistFilterValues,
    HelixSearchV2SortBy,
    HelixSearchV2SortDirection,
} from '../api/helixSearchV2/models/HelixSearchV2Results'

export function convertShortlistedSelectedToV2FilterValue(
    shortlistedSelected: string[],
): HelixSearchV2ShortlistFilterValues[] {
    const values: HelixSearchV2ShortlistFilterValues[] = []
    if (shortlistedSelected.includes('yes')) {
        values.push(HelixSearchV2ShortlistFilterValues.yes)
    }
    if (shortlistedSelected.includes('no')) {
        values.push(HelixSearchV2ShortlistFilterValues.no)
    }
    if (shortlistedSelected.includes('blanks')) {
        values.push(HelixSearchV2ShortlistFilterValues.none)
    }

    return values
}

export function convertOrderByToV2SortBy(orderBy: string): {
    sortBy: HelixSearchV2SortBy
    direction: HelixSearchV2SortDirection
} {
    const [sortBy, direction] = orderBy.split('_')
    return {
        sortBy: HelixSearchV2SortBy[sortBy as keyof typeof HelixSearchV2SortBy],
        direction:
            HelixSearchV2SortDirection[
                direction as keyof typeof HelixSearchV2SortDirection
            ],
    }
}

export function convertMinRelationshipScoreToNumber(
    minRelationshipScore: string,
): number | undefined {
    if (minRelationshipScore === 'min_relationship_score_any') {
        return undefined
    }

    const parts = minRelationshipScore.split('_')

    // e.g. min_relationship_score_40 returns 40
    return parseInt(parts[parts.length - 1], 10)
}
